import { Result } from "antd";
import React from "react";

const Forbidden: React.FC = () => (
  <Result
    status="403"
    title="403"
    subTitle="Desculpe, você não tem acesso a essa página"
  />
);

export default Forbidden;
